(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabDevicesTypes', TabDevicesTypes);

    TabDevicesTypes.$inject = ['$resource'];

    function TabDevicesTypes ($resource) {
        var resourceUrl =  'api/tab-devices-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
